import React from 'react';
import { PhoneMockup } from '../components/Mobile/PhoneMockup';
import { MobileInteriorViewer } from '../components/Mobile/MobileInteriorViewer';
import { QuickNavInteriorViewer } from '../components/Mobile/QuickNavInteriorViewer';
import { OverviewInteriorViewer } from '../components/Mobile/OverviewInteriorViewer';
import { VariantSwitcher } from '../components/Mobile/VariantSwitcher';
interface MobilePageProps {
  variant: 'step-flow' | 'quick-nav' | 'overview';
}
export function MobilePage({
  variant
}: MobilePageProps) {
  const Viewer = variant === 'quick-nav' ? QuickNavInteriorViewer : variant === 'overview' ? OverviewInteriorViewer : MobileInteriorViewer;
  return <>
      {/* Desktop: side-by-side layout with switcher */}
      <div className="hidden md:flex min-h-screen bg-slate-950 items-center justify-center gap-8 p-8" data-id="element-2712">
        <VariantSwitcher data-id="element-2713" />
        {/* Phone Frame (inline instead of PhoneMockup's desktop wrapper) */}
        <div className="relative w-[390px] h-[844px] bg-black rounded-[55px] shadow-2xl border-[8px] border-slate-800 overflow-hidden ring-1 ring-white/10 shrink-0" data-id="element-2714">
          {/* Dynamic Island */}
          <div className="absolute top-3 left-1/2 -translate-x-1/2 w-[120px] h-[35px] bg-black rounded-full z-50 flex items-center justify-between px-3 shadow-[0_0_0_1px_rgba(255,255,255,0.05)]" data-id="element-2715">
            <div className="w-2.5 h-2.5 rounded-full bg-slate-800/80 shadow-inner" data-id="element-2716"></div>
            <div className="w-2.5 h-2.5 rounded-full bg-slate-800/80 shadow-inner" data-id="element-2717"></div>
          </div>
          {/* Screen Content */}
          <div className="absolute inset-0 bg-black overflow-hidden rounded-[47px]" data-id="element-2718">
            <Viewer data-id="element-2719" />
          </div>
          {/* Home Indicator */}
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 w-[140px] h-[5px] bg-white/50 rounded-full z-50 pointer-events-none" data-id="element-2720"></div>
        </div>
      </div>

      {/* Mobile: full-screen, no switcher */}
      <div className="md:hidden w-screen overflow-hidden bg-black fixed inset-0" style={{
      height: '100dvh'
    }} data-id="element-2721">
        <Viewer data-id="element-2722" />
      </div>
    </>;
}